import { action, observable } from "mobx";
import { Logger } from "bernie-logger";
import { SerializedData, Store } from "bernie-core";
import { ExtendedTemplateComponent } from "./typings";
import { ExperienceTemplate } from "experience-template-renderer-react";
import { Composition as FlexComposition, Template as FlexTemplate } from "src/typings/flexFramework/FlexDefinitions";
import { flexToExtendedTemplateComponent } from "./flexToExtendedExperienceTemplateComponent";
import { DescendantDepth } from "./descendantDepth";
import { FlexComponent, ModuleDefinition } from "src/typings/flexFramework/FlexComponent";

export class ExperienceTemplateStore extends Store {
  @observable
  public experienceTemplate: ExtendedTemplateComponent[];

  /* istanbul ignore next */
  public constructor(state: SerializedData = {}, logger: Logger) {
    super(state, logger);
  }

  /* istanbul ignore next */
  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setup(structureInput: FlexTemplate | FlexComposition | ExperienceTemplate) {
    const isFlexComposition = (
      structure: FlexTemplate | FlexComposition | ExperienceTemplate
    ): structure is FlexComposition => {
      return !!(structure as FlexComposition).page;
    };

    const isFlexTemplate = (
      structure: FlexTemplate | FlexComposition | ExperienceTemplate
    ): structure is FlexTemplate => {
      return !!(structure as FlexTemplate).regions;
    };

    const isExperienceTemplate = (
      structure: FlexTemplate | FlexComposition | ExperienceTemplate
    ): structure is ExperienceTemplate => {
      return !isFlexComposition(structure) && !isFlexTemplate(structure);
    };

    if (isExperienceTemplate(structureInput)) {
      // wrap single TemplateComponent in array if necessary
      this.experienceTemplate =
        (structureInput as ExtendedTemplateComponent[]).length !== undefined
          ? (structureInput as ExtendedTemplateComponent[])
          : [structureInput as ExtendedTemplateComponent];
    } else {
      // convert legacy Flex structures to ExperienceTemplate
      this.experienceTemplate = [];

      const flexEntities: FlexComponent[] | ModuleDefinition[] = isFlexComposition(structureInput)
        ? structureInput.page.regionList
        : structureInput.regions;

      flexEntities.forEach((fe: FlexComponent | ModuleDefinition) => {
        this.experienceTemplate.push(flexToExtendedTemplateComponent(fe, DescendantDepth.ALL));
      });
    }
  }
}
